import { supabase } from '@/lib/supabase';
import type { SeoMeta } from '@/types/db';

export async function getAllSeo(): Promise<SeoMeta[]> {
  const { data, error } = await supabase.from('seo_meta').select('*');
  if (error) throw error;
  return data ?? [];
}

export async function getSeo(slug: string): Promise<SeoMeta | null> {
  const { data, error } = await supabase.from('seo_meta').select('*').eq('slug', slug).maybeSingle();
  if (error) throw error;
  return data;
}

export async function upsertSeo(entry: Partial<SeoMeta> & { slug: string }): Promise<SeoMeta> {
  const { data, error } = await supabase.from('seo_meta').upsert(entry).select().single();
  if (error) throw error;
  return data;
}
